<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name"
      >{{ label }}<span v-if="required" class="text-red-600">*</span></label
    >
    <!-- <Field :name="name" :value="'A'" v-slot="{ field }"> -->
    <Multiselect
      ref="dropdown"
      v-model="inputValue"
      mode="tags"
      @change="handleChange"
      @clear="inputValue = undefined"
      :options="combinedOptions"
    ></Multiselect>
    <p class="text-red-500" v-show="errorMessage || meta.valid">
      {{ errorMessage }}
    </p>
    <!-- </Field> -->
    <!-- <ErrorMessage :name="name"></ErrorMessage> -->
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

import { toRef } from 'vue';
import { useField } from 'vee-validate';
import * as yup from 'yup';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Multiselect from '@vueform/multiselect';
import { appendSpinner, removeSpinner } from '@/helpers';
import { useFilterStore } from '@/store/filterStore.js';
export default {
  name: '',
  props: {
    value: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
    },
    property: {
      type: Number,
      default: undefined,
    },
  },
  components: {
    Multiselect,
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      isLoading: false, // Loading state to prevent duplicate fetches
    };
  },
  watch: {
    isLoading(newVal) {
      if (newVal) {
        appendSpinner(this.$refs.dropdown.$el.querySelector('.multiselect-options'));
      } else {
        removeSpinner(this.$refs.dropdown.$el.querySelector('.multiselect-options'));
      }
    },
  },
  setup(props) {
    const { t } = useI18n();
    const name = toRef(props, 'name');
    let rules = yup.array().min(1, 'Choose at least one').required(t('warning.REQUIRED_MESSAGE'));
    const {
      meta,
      value: inputValue,
      errorMessage,
      validate,
      handleBlur,
      handleChange,
    } = useField(name, rules, {
      initialValue: props.value,
    });
    return {
      inputValue,
      errorMessage,
      validate,
      meta,
      handleBlur,
      handleChange,
    };
  },
  methods: {
    async validateField() {
      const validatedData = await this.validate();

      const arr = Array.isArray(this.inputValue) ? this.inputValue : [];
      const normalized = arr.map(v => Number(v)).filter(v => Number.isInteger(v) && v > 0);

      return {
        value: normalized,
        valid: validatedData.valid,
        mode: 'multi',
        property: this.property,
      };
    },

    async loadAllOptions() {
      // если property не задан — берём props.options как раньше
      if (!this.property) return;

      const store = useFilterStore();
      this.isLoading = true;
      try {
        await store.loadAllSelectValues(this.property);
      } finally {
        this.isLoading = false;
      }
    },
  },

  computed: {
    combinedOptions() {
      const store = useFilterStore();
      const items = (this.property && store.optionsByProperty?.[this.property])?.length
        ? store.optionsByProperty[this.property]
        : this.options || [];

      if (!items || !items.length) return [];

      return items.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
  },

  mounted() {
    this.loadAllOptions();
  },
  beforeUnmount() {},
};
</script>

<style>
@import '@vueform/multiselect/themes/tailwind.css';
</style>
